<template>
  <div class="invoice-detail-page" id="pageContainer" v-if="loading">
    <div class="content">
      <ul class="listInfo">
        <li class="item">
          <span class="item-name">抬头类型</span>
          <span class="item-value">{{
            data.buyerType == 1 ? "个人" : "企业单位"
          }}</span>
        </li>
        <li class="item">
          <span class="item-name">发票抬头</span>
          <span class="item-value">
            {{ data.buyerName }}
          </span>
        </li>

        <li class="item" v-if="data.buyerTaxNo">
          <span class="item-name">纳税人识别号</span>
          <span class="item-value">{{ data.buyerTaxNo }}</span>
        </li>

        <li class="item">
          <span class="item-name">发票项目</span>
          <span class="item-value">{{ data.invoiceItem }}</span>
        </li>
        <li class="item">
          <span class="item-name">开票金额</span>
          <span class="item-value" style="color: '#CD0014'"
            >￥{{ data.totalAmount }}</span
          >
        </li>
        <li class="item">
          <span class="item-name">开票申请编号</span>
          <span class="item-value">{{ data.invoiceSn }}</span>
        </li>
        <li class="item">
          <span class="item-name">电子邮箱</span>
          <span class="item-value">{{ data.buyerEmail }}</span>
        </li>
      </ul>
    </div>
    <div class="cfResult">
      <div class="topInfo">
        <div class="invoiceNum">开票数量{{ data.items.length }}张</div>
        <div class="tip" v-if="data.items.length > 1">
          申请开票金额过大，已自动为您拆分为多张发票。
        </div>
      </div>
      <ul class="lists">
        <li class="item" v-for="(item, index) in data.items" :key="index">
          <div class="itemEle">
            <span class="item-name">开票状态</span>

            <span :class="['item-value', item.status == 3 ? 'danger' : null]">{{
              renderStatus(item.status)
            }}</span>
          </div>
          <div class="itemEle">
            <span class="item-name">发票内容</span>
            <span class="item-value">{{ item.invoiceItem }}</span>
          </div>
          <div class="itemEle">
            <span class="item-name">开票方</span>
            <span class="item-value">{{ item.financeMainName }}</span>
          </div>
          <div class="itemEle">
            <span class="item-name">发票金额</span>
            <span class="item-value blo">￥{{ item.amount }}</span>
          </div>
          <div className="dangerInfo" v-if="item.status == 3">
            已取消开票，如有疑问，请联系客服或班主任。
          </div>
        </li>
      </ul>
    </div>
    <a class="callPhone" :href="`tel:${phone}`"
      ><i></i> <span>如有问题，请联系客服/班主任</span></a
    >
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import { getUrlParameter } from "@/utils/utils.js";
export default {
  data() {
    return {
      phone: "",
      statusValue: "",
      loading: false,
      data: {
        totalAmount: "",
        buyerType: 0,
        buyerName: "",
        buyerTaxNo: "",
        invoiceItem: "",
        buyerEmail: "",
        invoiceSn: "",
        items: [],
      },
    };
  },
  mounted() {
    window.dhsdk.titleChanged({
      title: "开票详情",
    });
    this.loading = false;
    this.changeLoading(true);
    // 请求发票id对应的详情信息
    this.$api.invoice
      .invoiceDetail({
        invoiceId: getUrlParameter("id"),
      })
      .then((res) => {
        this.loading = true;
        if (res.errcode == 0) {
          this.data = res.data;
          this.changeLoading(false);
        } else {
          this.$toast(`获取失败：${res.msg}`);
        }
      });
    //电话号码获取请求
    this.$api.classes
      .getConfig({
        module_alias: "parent_common_config",
        key: "common_text",
      })
      .then((res) => {
        this.phone = res.contact_information.customer_service.phone;
      });
  },
  methods: {
    ...mapMutations({
      changeLoading: "changeLoading",
    }),
    renderStatus(v) {
      if (v == 1) {
        return "开票中";
      } else if (v == 2) {
        return "已开票";
      } else if (v == 3) {
        return "退票中";
      } else if (v == 4) {
        return "已退票";
      } else if (v == 5) {
        return "开票失败";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.invoice-detail-page {
  padding-top: 20px;
  min-height: 100vh;
  padding-bottom: 20px;
  background: rgba(247, 247, 247, 1);
  .content {
    padding: 20px 15px;
    width: 345px;
    background-color: #ffffff;
    position: relative;
    font-weight: 400;
    border-radius: 7px;
    margin: 0 auto 10px;
    border: 1px solid transparent;
    .listInfo {
      .item {
        font-size: 15px;
        margin-bottom: 7px;
        overflow: hidden;
        span {
          display: inline-block;
          line-height: 25px;
        }
        .item-name {
          display: block;
          color: rgba(204, 204, 204, 1);
          margin-right: 25px;
          float: left;
        }
        .item-value {
          display: block;
          color: #333333;
          overflow: hidden;
          word-break: break-all;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  .cfResult {
    font-family: PingFangSC-Medium, PingFang SC;
    width: 345px;
    padding: 20px 15px;
    background-color: #ffffff;
    margin: 0 auto;
    border-radius: 7px;
    .topInfo {
      padding-bottom: 12px;
      .invoiceNum {
        font-weight: 500;
        line-height: 18px;
        font-size: 18px;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 10px;
      }
      .tip {
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 12px;
        font-size: 12px;
      }
    }
    .lists {
      .item {
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        border-top: 1px solid rgba(236, 236, 236, 1);
        padding-top: 20px;
        .dangerInfo {
          width: 305px;
          height: 28px;
          background: rgba(253, 236, 226, 1);
          border-radius: 40px;
          font-weight: 400;
          color: rgba(237, 125, 58, 1);
          font-size: 12px;
          line-height: 28px;
          padding-left: 15px;
          margin: 0 auto 20px;
        }
        .itemEle {
          width: 100%;
          height: 14px;
          line-height: 14px;
          margin-bottom: 15px;
          span {
            display: inline-block;
          }
          .item-name {
            float: left;
          }
          .item-value {
            float: right;
            color: #666666;
            &.blo {
              color: rgba(51, 51, 51, 1);
            }
            &.danger {
              color: #cd0014;
            }
          }
        }
      }
    }
  }
  .callPhone {
    width: 275px;
    height: 50px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 25px;
    text-align: center;
    font-size: 15px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    margin: 25px auto 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      display: inline-block;
      width: 23px;
      height: 23px;
      // background-color: red;
      background-image: url("~@/assets/img/issueInvoice/phone.png");
      vertical-align: middle;
      background-repeat: no-repeat;
      background-size: 100% 99.9%;
      margin-right: 11px;
    }
  }
}
</style>
